import { StyleSheet } from 'react-native';

import { WINDOW_WIDTH } from '@gorhom/bottom-sheet';

import { COLOR } from 'utils/colors';
import { isTabletOrWeb, widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    button: {
        alignSelf: 'flex-start',
        width: isTabletOrWeb ? 'auto' : '100%',
        minWidth: widthPercentageToDP(120),
        maxWidth: isTabletOrWeb
            ? WINDOW_WIDTH - widthPercentageToDP(44 * 2)
            : null,
        paddingHorizontal: 18,
        marginTop: 0,
        marginBottom: 24,
    },
    buttonText: {
        marginRight: 8,
        color: COLOR.background,
    },
});

export default styles;
